import { useEffect, useState } from "react";
import ILoaderObject from "./contracts/ILoaderObject";
import { LOADER_STATUS } from "./contracts/TLoaderStatus";
import ILoader from "./contracts/ILoader";
import IException from "../../contracts/IException";

interface IProps {
  loaderName: string;
  loadAsync: () => void;
  maxRetryCount?: number;
}
function useLoader({ loaderName, loadAsync, maxRetryCount = 6 }: IProps) {

  function GET_LOADER_DEFAULT(): ILoaderObject {
    return { status: LOADER_STATUS.DEFAULT, title: loaderName, message: '', loadAsync }
  }

  const [loader, setLoader] = useState<ILoaderObject>(GET_LOADER_DEFAULT());
  const [showDialog, setShowDialog] = useState<boolean>(false);
  const [retryCount, setRetryCount] = useState<number>(0);


  const [isDefault, setIsDefault] = useState<boolean>(true);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isNotLoading, setNotIsLoading] = useState<boolean>(true);
  const [isFailure, setIsFailure] = useState<boolean>(false);
  const [isSuccess, setIsSuccess] = useState<boolean>(false);
  const [isCompleted, setIsCompleted] = useState<boolean>(false);

  useEffect(() => {
    const isDefault: boolean = loader.status === LOADER_STATUS.DEFAULT;
    const isLoading: boolean = loader.status === LOADER_STATUS.LOADING;
    const isFailure: boolean = loader.status === LOADER_STATUS.FAILURE;
    const isSuccess: boolean = loader.status === LOADER_STATUS.SUCCESS;

    setIsDefault(isDefault);

    setIsLoading(isLoading);
    setNotIsLoading(!isLoading);

    setIsFailure(isFailure);
    setIsSuccess(isSuccess);

    setIsCompleted(isSuccess || isFailure);

    setShowDialog(isLoading || isFailure);

  }, [loader.status])


  function RESET() {
    setLoader(GET_LOADER_DEFAULT());
  }

  function SET_LOADING(message: string = 'loading...') {
    setLoader({ ...loader, status: LOADER_STATUS.LOADING, message });
  }

  function SET_SUCCESS(message: string = 'success') {
    setLoader({ ...loader, status: LOADER_STATUS.SUCCESS, message });
  }

  function SET_FAILURE(message: string = 'failed') {
    setLoader({ ...loader, status: LOADER_STATUS.FAILURE, message });
  }

  function SET_EXCEPTION(exception: IException) {
    SET_FAILURE(exception.title + ' - ' + exception.message);
  }

  function RETRY() {
    if (retryCount < maxRetryCount) {
      setRetryCount(retryCount + 1);
      loadAsync();
    }
  }

  return {
    retryCount, maxRetryCount, loadAsync, loaderName, loader,
    isDefault, isLoading, isNotLoading, isFailure, isSuccess, isCompleted, showDialog,
    RESET, RETRY, SET_LOADING, SET_SUCCESS, SET_FAILURE, SET_EXCEPTION,
  } as ILoader;
}
export default useLoader;